import {createContext, useContext} from "react";
import {DynamicFormFieldDefinition} from "qqq/components/forms/DynamicFormUtils";

export type RowBannerState =
   | {kind: "none"}
   | {kind: "hasFieldErrors"; errorFieldNames: string[]}
   | {kind: "formDisabled"; message: string}
   | {kind: "saveError"; message: string}
   | {kind: "saveSuccess"};

export interface RowEditContextValue
{
   editingRowId: string | number | null;
   /** Row that was just successfully saved — shows a brief "Saved" label. Null otherwise. */
   savedRowId: string | number | null;
   formFieldDefs: { [fieldName: string]: DynamicFormFieldDefinition };
   isSaving: boolean;
   rowBannerState: RowBannerState;
   requestSave: () => void;
   requestCancel: () => void;
   /** Triggers the on-change form-adjuster POST for the given field (invoked on blur from cell inputs). */
   handleFieldBlur?: (fieldName: string, value: any) => void;
}

export const RowEditContext = createContext<RowEditContextValue | null>(null);

export function useRowEditContext(): RowEditContextValue | null
{
   return useContext(RowEditContext);
}
